import * as i0 from '@angular/core';
import { Component, Input, NgModule, Injectable } from '@angular/core';
import * as i1 from '@ft-alts/ui-components/src/lib/shared-lib';
import { getModelFromRef, PipesModule, SwitchModule, ButtonModule } from '@ft-alts/ui-components/src/lib/shared-lib';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import cloneDeep from 'lodash/cloneDeep';
import * as i3 from 'highcharts-angular';
import { HighchartsChartModule } from 'highcharts-angular';

function PerfHeaderComponent_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function PerfHeaderComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subTitle, " ");
} }
function PerfHeaderComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r2.link.href, i0.ɵɵsanitizeUrl)("target", ctx_r2.link.target);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.link.text, " ");
} }
const _c0$6 = function (a0) { return { "perf-header__bg-color--default": a0 }; };
const _c1$3 = function (a0) { return { "perf-header__responsive": a0 }; };
class PerfHeaderComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        /**
         * Optional prop to set background color of the section.
         */
        this.bgColor = 'default';
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having header content
     */
    mapContent(document) {
        var _a;
        const { title, subTitle, link, bgColor } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.title = title;
        this.subTitle = subTitle;
        this.link = link;
        if (bgColor) {
            this.bgColor = bgColor;
        }
    }
}
PerfHeaderComponent.ɵfac = function PerfHeaderComponent_Factory(t) { return new (t || PerfHeaderComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService)); };
PerfHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfHeaderComponent, selectors: [["ft-alts-perf-header"]], inputs: { component: "component", page: "page" }, decls: 9, vars: 11, consts: [[1, "perf-header", 3, "ngClass"], [1, "grid"], [1, "row", "color--ft-white", 3, "ngClass"], [1, "col", "l6", "m6", "s4"], ["class", "spacing--xs", 4, "ngIf"], [4, "ngIf"], [1, "col", "l4", "m6", "s4", "link-section"], [3, "href", "target", 4, "ngIf"], [1, "spacing--xs"], [3, "href", "target"]], template: function PerfHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, PerfHeaderComponent_h2_5_Template, 2, 1, "h2", 4);
        i0.ɵɵtemplate(6, PerfHeaderComponent_p_6_Template, 2, 1, "p", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, PerfHeaderComponent_a_8_Template, 2, 3, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$6, ctx.bgColor === "default"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$3, i0.ɵɵpipeBind1(3, 5, ctx.isHandheld$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.link);
    } }, directives: [i2.NgClass, i2.NgIf], pipes: [i2.AsyncPipe], styles: [".perf-header__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-header[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]{margin:0}@media (min-width: 1200px){.perf-header[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{max-width:970px}}.perf-header[_ngcontent-%COMP%]   .link-section[_ngcontent-%COMP%]{text-align:right}.perf-header__responsive[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.perf-header__responsive[_ngcontent-%COMP%]   .link-section[_ngcontent-%COMP%]{text-align:left!important;margin-bottom:var(--space-md)!important}.perf-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-family:var(--fonts-link-underline-font-family);font-size:var(--fonts-link-underline-font-size-small-desktop);font-weight:400;line-height:var(--fonts-link-underline-line-height);text-decoration:underline;color:var(--ft-white)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-header',
                templateUrl: './perf-header.component.html',
                styleUrls: ['./perf-header.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfHeaderModule {
}
PerfHeaderModule.ɵfac = function PerfHeaderModule_Factory(t) { return new (t || PerfHeaderModule)(); };
PerfHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfHeaderModule });
PerfHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfHeaderComponent],
                imports: [CommonModule],
                exports: [PerfHeaderComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfHeaderModule, { declarations: [PerfHeaderComponent], imports: [CommonModule], exports: [PerfHeaderComponent] }); })();

class PerfTabsService {
    constructor() {
        this.tabSelected = new Subject();
    }
    /**
     * Return selected tab event as observable.
     */
    getSelectedTabNumber$() {
        return this.tabSelected.asObservable();
    }
    /**
     * Emit the selected tab event with current tab number.
     * @param currentTabNumber current active tab
     */
    onPerfTabSelected(currentTabNumber) {
        this.tabSelected.next(currentTabNumber);
    }
}
PerfTabsService.ɵfac = function PerfTabsService_Factory(t) { return new (t || PerfTabsService)(); };
PerfTabsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PerfTabsService, factory: PerfTabsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0$5 = function (a0) { return { active: a0 }; };
function PerfTabsComponent_div_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function PerfTabsComponent_div_3_button_1_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const i_r3 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onPerfTabSelected(i_r3); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabName_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$5, ctx_r1.activeTabNumber === i_r3));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", tabName_r2, " ");
} }
const _c1$2 = function (a0) { return { "perf-tabs__bg-color--default": a0 }; };
function PerfTabsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, PerfTabsComponent_div_3_button_1_Template, 2, 4, "button", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$2, ctx_r0.bgColor === "default"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.tabNames);
} }
class PerfTabsComponent {
    constructor(perfTabsService) {
        this.perfTabsService = perfTabsService;
        /**
         * Name of the tabs of type string array.
         */
        this.tabNames = [];
        /**
         * Optional param to set background color of the tabs.
         */
        this.bgColor = 'default';
        /**
         * Class variable to track current active tab.
         */
        this.activeTabNumber = 0;
    }
    ngOnInit() {
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having performance tabs content
     */
    mapContent(document) {
        var _a;
        const { tabNames, bgColor } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.tabNames = tabNames;
        if (bgColor) {
            this.bgColor = bgColor;
        }
    }
    /**
     * Save current tab number and emit its "selected event", when tab is selected.
     * @param currentTabNumber current active tab
     */
    onPerfTabSelected(currentTabNumber) {
        this.activeTabNumber = currentTabNumber;
        this.perfTabsService.onPerfTabSelected(currentTabNumber);
    }
}
PerfTabsComponent.ɵfac = function PerfTabsComponent_Factory(t) { return new (t || PerfTabsComponent)(i0.ɵɵdirectiveInject(PerfTabsService)); };
PerfTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabsComponent, selectors: [["ft-alts-perf-tabs"]], inputs: { component: "component", page: "page" }, decls: 4, vars: 1, consts: [[1, "grid"], [1, "row"], [1, "col", "l12", "m8", "s4"], ["class", "perf-tabs", 3, "ngClass", 4, "ngIf"], [1, "perf-tabs", 3, "ngClass"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"]], template: function PerfTabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, PerfTabsComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.tabNames == null ? null : ctx.tabNames.length);
    } }, directives: [i2.NgIf, i2.NgClass, i2.NgForOf], styles: [".perf-tabs[_ngcontent-%COMP%]{display:flex;grid-gap:24px;gap:24px;overflow-x:auto;white-space:nowrap;padding-bottom:8px}.perf-tabs[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:1px solid var(--ft-sky-blue);border-radius:24px;padding:16px 24px;background-color:var(--ft-complementary-sky-blue-1);color:var(--ft-sky-blue);transition:background-color .3s,color .3s;cursor:pointer;outline-offset:-1px;font-size:var(--fonts-button-small-font-size-small-desktop);font-family:var(--fonts-button-small-font-family);font-weight:var(--fonts-button-small-font-weight);line-height:var(--fonts-button-small-line-height)}.perf-tabs[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .perf-tabs[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:var(--ft-sky-blue);color:var(--ft-white)}.perf-tabs__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar{height:6px}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--ft-complementary-sky-blue-1);border-radius:3px}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:var(--ft-alts-dark-blue)}@media (min-width: 1200px){.row[_ngcontent-%COMP%]{max-width:970px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tabs',
                templateUrl: './perf-tabs.component.html',
                styleUrls: ['./perf-tabs.component.scss'],
            }]
    }], function () { return [{ type: PerfTabsService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfTabsModule {
}
PerfTabsModule.ɵfac = function PerfTabsModule_Factory(t) { return new (t || PerfTabsModule)(); };
PerfTabsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabsModule });
PerfTabsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [PerfTabsService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabsComponent],
                imports: [CommonModule],
                exports: [PerfTabsComponent],
                providers: [PerfTabsService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabsModule, { declarations: [PerfTabsComponent], imports: [CommonModule], exports: [PerfTabsComponent] }); })();

const _c0$4 = function (a0) { return { "perf-table__hide-element": a0 }; };
function PerfTableComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function PerfTableComponent_div_0_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onSvgButtonClick(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 6);
    i0.ɵɵelementStart(2, "g", 7);
    i0.ɵɵelement(3, "circle", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$4, ctx_r1.isSvgButtonClicked));
} }
function PerfTableComponent_div_0_th_9_sup_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", headData_r6.footnote, " ");
} }
function PerfTableComponent_div_0_th_9_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(headData_r6.subLabel);
} }
function PerfTableComponent_div_0_th_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PerfTableComponent_div_0_th_9_sup_2_Template, 2, 1, "sup", 10);
    i0.ɵɵelement(3, "br");
    i0.ɵɵtemplate(4, PerfTableComponent_div_0_th_9_span_4_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", headData_r6.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", headData_r6.footnote);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", headData_r6.subLabel);
} }
function PerfTableComponent_div_0_tr_11_td_1_sup_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r13.footnote, " ");
} }
function PerfTableComponent_div_0_tr_11_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "ftAltsDashIfEmpty");
    i0.ɵɵtemplate(3, PerfTableComponent_div_0_tr_11_td_1_sup_3_Template, 2, 1, "sup", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, row_r13.value), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", row_r13.footnote);
} }
function PerfTableComponent_div_0_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, PerfTableComponent_div_0_tr_11_td_1_Template, 4, 4, "td", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const bodyData_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", bodyData_r11);
} }
const _c1$1 = function (a0, a1) { return { "perf-table__overflow--hidden": a0, "perf-table__overflow--scroll": a1 }; };
const _c2 = function (a0) { return { "perf-table__scroll-button-bg-gradient": a0 }; };
function PerfTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PerfTableComponent_div_0_div_3_Template, 5, 3, "div", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementStart(5, "table", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "thead");
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵtemplate(9, PerfTableComponent_div_0_th_9_Template, 5, 3, "th", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵtemplate(11, PerfTableComponent_div_0_tr_11_Template, 2, 1, "tr", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c1$1, i0.ɵɵpipeBind1(1, 5, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked, i0.ɵɵpipeBind1(2, 7, ctx_r0.isHandheld$) && ctx_r0.isSvgButtonClicked));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 9, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c2, i0.ɵɵpipeBind1(6, 11, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.updatedTableData.head);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.updatedTableData.body);
} }
class PerfTableComponent {
    constructor(responsiveService, cdr) {
        this.responsiveService = responsiveService;
        this.cdr = cdr;
        this.isSvgButtonClicked = false;
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.tableData.currentValue) {
            this.updatedTableData = simpleChanges.tableData.currentValue;
            this.cdr.detectChanges();
        }
    }
    /**
     * Make flag 'isSvgButtonClicked' truthy when its clicked.
     */
    onSvgButtonClick() {
        this.isSvgButtonClicked = true;
    }
}
PerfTableComponent.ɵfac = function PerfTableComponent_Factory(t) { return new (t || PerfTableComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTableComponent, selectors: [["ft-alts-perf-table"]], inputs: { tableData: "tableData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "perf-table", 3, "ngClass", 4, "ngIf"], [1, "perf-table", 3, "ngClass"], ["class", "perf-table__scroll-button-svg", 3, "ngClass", "click", 4, "ngIf"], [1, "font-small--b", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "perf-table__scroll-button-svg", 3, "ngClass", "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "76", "height", "76", "viewBox", "0 0 76 76", "fill", "none"], ["filter", "url(#filter0_d_4267_79595)"], ["cx", "38", "cy", "33", "r", "28", "fill", "white"], ["d", "M38.0002 44.6666L36.4689 43.0989L45.4741 34.0937H26.3335V31.9062H45.4741L36.4689 22.901L38.0002 21.3333L49.6668 32.9999L38.0002 44.6666Z", "fill", "#3769FF"], [4, "ngIf"], ["className", "font-small", 4, "ngIf"], ["className", "font-small"]], template: function PerfTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTableComponent_div_0_Template, 12, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.updatedTableData);
    } }, directives: [i2.NgIf, i2.NgClass, i2.NgForOf], pipes: [i2.AsyncPipe, i1.DashIfEmptyPipe], styles: [".perf-table[_ngcontent-%COMP%]{width:100%;position:relative;overflow-x:auto}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{background-color:var(--ft-complementary-sky-blue-4);color:var(--ft-white)}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{background-color:var(--ft-light-grey)}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:16px;white-space:nowrap;font-weight:600}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type{text-align:left}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:not(:first-of-type):not(:last-of-type), .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:first-of-type):not(:last-of-type){text-align:center}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{text-align:right}.perf-table__scroll-button-bg-gradient[_ngcontent-%COMP%]{position:relative}.perf-table__scroll-button-bg-gradient[_ngcontent-%COMP%]:before{content:\"\";position:absolute;width:100vw;height:100%;margin-top:-9%;background:linear-gradient(272.68deg,#263154 -28.11%,rgba(132,140,165,.271219) 58.95%,rgba(169,178,204,0) 91.34%)}.perf-table__scroll-button-svg[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;top:calc(50% - 38px);left:50vw;z-index:3;opacity:1}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar{height:6px}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--ft-complementary-sky-blue-1);border-radius:3px}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:var(--ft-alts-dark-blue)}.perf-table__hide-element[_ngcontent-%COMP%]{display:none}.perf-table__overflow--hidden[_ngcontent-%COMP%]{overflow:hidden}.perf-table__overflow--scroll[_ngcontent-%COMP%]{overflow-x:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTableComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-table',
                templateUrl: './perf-table.component.html',
                styleUrls: ['./perf-table.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i0.ChangeDetectorRef }]; }, { tableData: [{
            type: Input
        }] }); })();

function PerfChartComponent_highcharts_chart_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "highcharts-chart", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("Highcharts", ctx_r0.highcharts)("options", ctx_r0.highchartsOptions);
} }
const _c0$3 = function (a0) { return { "perf-chart__bg-color--default": a0 }; };
// Respective colors of the series plotted.
const COLORS = ['#00BFB3', '#3769FF', '#C042EA', '#D5E4FD'];
// Fixed width of each column plotted in pixels.
const COLUMN_WIDTH = 50;
class PerfChartComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        /**
         * Optional prop to register chart type. Default is 'column' chart.
         */
        this.type = 'column';
        /**
         * Optional prop to set background color of the chart.
         */
        this.bgColor = 'default';
        this.highchartsOptions = {};
    }
    ngOnInit() {
        this.subscription = this.responsiveService
            .isHandheld$()
            .subscribe((isHandheld) => {
            this.isHandheld = isHandheld;
            this.highchartsOptions = this.getHighchartsOptions(); // Recalculate options with updated column width.
        });
        import(/* webpackChunkName: "highcharts-async" */ 'highcharts').then((highchartsModule) => {
            this.highcharts = highchartsModule;
            this.highchartsOptions = this.getHighchartsOptions();
        });
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.chartData.currentValue) {
            this.updatedChartData = simpleChanges.chartData.currentValue;
            this.highchartsOptions = this.getHighchartsOptions();
        }
    }
    /**
     * Return comprehensive set of highcharts options required for plotting.
     */
    getHighchartsOptions() {
        var _a;
        return {
            chart: {
                type: this.type,
                backgroundColor: null,
                height: this.chartHeight ? this.chartHeight : undefined,
            },
            accessibility: {
                enabled: true,
                keyboardNavigation: {
                    enabled: true,
                },
            },
            title: {
                text: null,
            },
            xAxis: {
                type: 'category',
                categories: (_a = this.updatedChartData) === null || _a === void 0 ? void 0 : _a.xAxis,
                lineWidth: 0,
                labels: {
                    useHTML: true,
                    style: {
                        fontFamily: 'TTCommonsProRegular',
                        fontSize: '13',
                        color: '#FFFFFF',
                        paddingTop: '20px',
                        paddingBottom: '10px',
                    },
                },
            },
            yAxis: {
                title: {
                    text: null,
                },
                gridLineWidth: 1,
                gridLineDashStyle: 'Dash',
                tickInterval: 2,
                lineColor: '#BFBFBF',
                labels: {
                    style: {
                        fontFamily: 'TTCommonsProRegular',
                        fontSize: '13',
                        color: '#FFFFFF',
                    },
                    formatter: function () {
                        return Number(this.value).toFixed(1);
                    },
                },
            },
            tooltip: {
                backgroundColor: '#FFFFFF',
                padding: 8,
                borderRadius: 10,
                shadow: false,
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13px',
                    color: '#212121',
                },
                headerFormat: '<table>',
                pointFormat: '<tr><td>{series.name} </td></tr>' +
                    '<tr><td style="padding:0"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
                shared: false,
                useHTML: true,
            },
            plotOptions: {
                column: {
                    borderWidth: 0,
                    pointWidth: this.isHandheld ? null : COLUMN_WIDTH,
                    pointPadding: 0.2,
                    groupPadding: 0.2,
                },
                series: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            legend: {
                align: 'left',
                symbolWidth: 15,
                symbolHeight: 15,
                symbolRadius: 0,
                itemStyle: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                    fontWeight: '400',
                },
                itemHoverStyle: {
                    color: '#FFFFFF',
                    cursor: 'default',
                },
                itemMarginTop: 10,
            },
            series: this.getSeriesData(),
        };
    }
    /**
     * Prepare and return complete series data.
     * Supports multiple plots with color (upto 'N' count available in 'COLORS' declared) and hover details.
     */
    getSeriesData() {
        var _a;
        return (_a = this.updatedChartData) === null || _a === void 0 ? void 0 : _a.yAxis.map((yAxisPlots, index) => {
            var _a;
            return {
                type: this.type,
                name: (_a = this.updatedChartData) === null || _a === void 0 ? void 0 : _a.name[index],
                data: yAxisPlots,
                color: COLORS[index],
                point: {
                    events: {
                        mouseOver: function () {
                            const series = this.series;
                            series.points.forEach((point) => {
                                point.graphic.css({
                                    opacity: 0.7,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            });
                            this.graphic.css({
                                opacity: 1,
                                transition: 'opacity 0.3s ease-in-out',
                            });
                        },
                        mouseOut: function () {
                            const series = this.series;
                            series.points.forEach((point) => {
                                point.graphic.css({
                                    opacity: 1,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            });
                        },
                    },
                },
            };
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
PerfChartComponent.ɵfac = function PerfChartComponent_Factory(t) { return new (t || PerfChartComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService)); };
PerfChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfChartComponent, selectors: [["ft-alts-perf-chart"]], inputs: { type: "type", chartHeight: "chartHeight", bgColor: "bgColor", chartData: "chartData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 4, consts: [[3, "ngClass"], ["class", "perf-chart__responsive", 3, "Highcharts", "options", 4, "ngIf"], [1, "perf-chart__responsive", 3, "Highcharts", "options"]], template: function PerfChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PerfChartComponent_highcharts_chart_1_Template, 1, 2, "highcharts-chart", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$3, ctx.bgColor === "default"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.chartData && ctx.highcharts);
    } }, directives: [i2.NgClass, i2.NgIf, i3.HighchartsChartComponent], styles: [".perf-chart__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-chart__responsive[_ngcontent-%COMP%]{width:100%;display:block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfChartComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-chart',
                templateUrl: './perf-chart.component.html',
                styleUrls: ['./perf-chart.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }]; }, { type: [{
            type: Input
        }], chartHeight: [{
            type: Input
        }], bgColor: [{
            type: Input
        }], chartData: [{
            type: Input
        }] }); })();

function PerfTabAverageAnnualComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "ft-alts-switch", 12);
    i0.ɵɵlistener("switchState", function PerfTabAverageAnnualComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r1.switchdata.offLabel)("onLabel", ctx_r1.switchdata.onLabel)("state", ctx_r1.switchdata.state);
} }
function PerfTabAverageAnnualComponent_div_0_ft_alts_perf_chart_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r2.selectedPerformanceData.chartConfig == null ? null : ctx_r2.selectedPerformanceData.chartConfig.chartType)("chartHeight", ctx_r2.selectedPerformanceData.chartConfig == null ? null : ctx_r2.selectedPerformanceData.chartConfig.chartHeight)("bgColor", ctx_r2.bgColor)("chartData", ctx_r2.chartData);
} }
const _c0$2 = function (a0) { return { "pt-avg-annual__chart-header": a0 }; };
function PerfTabAverageAnnualComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementStart(6, "h2", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabAverageAnnualComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PerfTabAverageAnnualComponent_div_0_ft_alts_perf_chart_11_Template, 1, 4, "ft-alts-perf-chart", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "ft-alts-perf-table", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$2, !i0.ɵɵpipeBind1(5, 6, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.switchdata);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tableData", ctx_r0.tableData);
} }
class PerfTabAverageAnnualComponent {
    constructor(responsiveService, cdr) {
        this.responsiveService = responsiveService;
        this.cdr = cdr;
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having performance tab content
     */
    mapContent(document) {
        var _a;
        const tabData = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        if (tabData) {
            this.bgColor = tabData.bgColor;
            this.tabTitle = tabData.title;
            this.switchdata = tabData.switchdata;
            this.categories = tabData.categories;
            this.performanceMetadata = tabData.performanceMetadata;
            if (this.performanceMetadata) {
                this.onSwitchPressed(this.switchdata.state);
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare chart & table data accordingly.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata.monthEnd);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata.quarterEnd);
        }
        // Step 2: Get chart data processed accordingly.
        this.chartData = this.prepareChartData(this.selectedPerformanceData.chartData);
        // Step 3: Get table data by processing updated chart data and other details from selected performance data.
        this.tableData = this.prepareTableData(this.chartData, this.selectedPerformanceData.asOfDate, this.selectedPerformanceData.sinceInceptionDate, currentState);
        // Step 4: Finally, update the child components - chart & table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform chart raw data into a feasible data structure as required by chart component.
     * @param chartRawMetaData
     * @returns complete chart data containing name & axes data.
     */
    prepareChartData(chartRawMetaData) {
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        chartRawMetaData === null || chartRawMetaData === void 0 ? void 0 : chartRawMetaData.forEach((chartRawData) => {
            chartData.name.push(chartRawData.class);
            chartData.yAxis.push(chartRawData.data);
        });
        chartData.xAxis = this.categories;
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses chart data for binding x-axes (categories) to table header, and, y-axes (plots) to table body.
     * @param chartData updated chart data
     * @param asOfDate as of date as per selected performance data
     * @param sinceInceptionDate since inception data as per selected performance data
     * @param currentState currently seleted switch state
     * @returns complete table metadata containing head & body values
     */
    prepareTableData(chartData, asOfDate, sinceInceptionDate, currentState) {
        const headData = [];
        const bodyData = [];
        // Step 1: Add row headers for table header & table body initially.
        headData.push({
            label: currentState === 'on'
                ? this.switchdata.onLabel
                : this.switchdata.offLabel,
            subLabel: asOfDate,
        });
        chartData.yAxis.forEach((plots, index) => {
            // Take care of multiple rows in a body through "array of objects" push, if present.
            bodyData.push([
                {
                    value: chartData.name[index],
                },
            ]);
        });
        // Step 2: Add remaining column data for table header & table body.
        headData.push(...chartData.xAxis.map((category, index) => {
            if (index === chartData.xAxis.length - 1) {
                return {
                    label: category,
                    subLabel: sinceInceptionDate,
                };
            }
            return {
                label: category,
            };
        }));
        chartData.yAxis.forEach((plots, index) => {
            // Take care of multiple rows in a body through 'index', if present.
            bodyData[index].push(...plots.map((plot) => {
                return {
                    value: String(plot),
                };
            }));
        });
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabAverageAnnualComponent.ɵfac = function PerfTabAverageAnnualComponent_Factory(t) { return new (t || PerfTabAverageAnnualComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfTabAverageAnnualComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabAverageAnnualComponent, selectors: [["ft-alts-perf-tab-average-annual"]], inputs: { component: "component", page: "page" }, decls: 1, vars: 1, consts: [["class", "pt-avg-annual", 4, "ngIf"], [1, "pt-avg-annual"], [1, "grid"], [1, "row", "pt-avg-annual__max-width-970"], [1, "col", "l12", "m8", "s4", "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "title--h4", "color--ft-white", "spacing--xs"], ["class", "spacing--lg", 4, "ngIf"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "type", "chartHeight", "bgColor", "chartData", 4, "ngIf"], [3, "tableData"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], [3, "type", "chartHeight", "bgColor", "chartData"]], template: function PerfTabAverageAnnualComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabAverageAnnualComponent_div_0_Template, 13, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i2.NgIf, i2.NgClass, PerfTableComponent, i1.SwitchComponent, PerfChartComponent], pipes: [i2.AsyncPipe], styles: ["@media (min-width: 1200px){.pt-avg-annual__max-width-970[_ngcontent-%COMP%]{max-width:970px}}.pt-avg-annual__chart-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabAverageAnnualComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-average-annual',
                templateUrl: './perf-tab-average-annual.component.html',
                styleUrls: ['./perf-tab-average-annual.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i0.ChangeDetectorRef }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfChartModule {
}
PerfChartModule.ɵfac = function PerfChartModule_Factory(t) { return new (t || PerfChartModule)(); };
PerfChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfChartModule });
PerfChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, HighchartsChartModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfChartModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfChartComponent],
                imports: [CommonModule, HighchartsChartModule],
                exports: [PerfChartComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfChartModule, { declarations: [PerfChartComponent], imports: [CommonModule, HighchartsChartModule], exports: [PerfChartComponent] }); })();

class PerfTableModule {
}
PerfTableModule.ɵfac = function PerfTableModule_Factory(t) { return new (t || PerfTableModule)(); };
PerfTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTableModule });
PerfTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, PipesModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTableModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTableComponent],
                imports: [CommonModule, PipesModule],
                exports: [PerfTableComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTableModule, { declarations: [PerfTableComponent], imports: [CommonModule, PipesModule], exports: [PerfTableComponent] }); })();

class PerfTabAverageAnnualModule {
}
PerfTabAverageAnnualModule.ɵfac = function PerfTabAverageAnnualModule_Factory(t) { return new (t || PerfTabAverageAnnualModule)(); };
PerfTabAverageAnnualModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabAverageAnnualModule });
PerfTabAverageAnnualModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabAverageAnnualModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabAverageAnnualComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule],
                exports: [PerfTabAverageAnnualComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabAverageAnnualModule, { declarations: [PerfTabAverageAnnualComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule], exports: [PerfTabAverageAnnualComponent] }); })();

class PerfTabCumulativeTotalComponent {
    constructor() { }
    ngOnInit() { }
}
PerfTabCumulativeTotalComponent.ɵfac = function PerfTabCumulativeTotalComponent_Factory(t) { return new (t || PerfTabCumulativeTotalComponent)(); };
PerfTabCumulativeTotalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabCumulativeTotalComponent, selectors: [["ft-alts-perf-tab-cumulative-total"]], decls: 2, vars: 0, template: function PerfTabCumulativeTotalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "perf-tab-cumulative-total works!");
        i0.ɵɵelementEnd();
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabCumulativeTotalComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-cumulative-total',
                templateUrl: './perf-tab-cumulative-total.component.html',
                styleUrls: ['./perf-tab-cumulative-total.component.scss'],
            }]
    }], function () { return []; }, null); })();

class PerfTabCumulativeTotalModule {
}
PerfTabCumulativeTotalModule.ɵfac = function PerfTabCumulativeTotalModule_Factory(t) { return new (t || PerfTabCumulativeTotalModule)(); };
PerfTabCumulativeTotalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabCumulativeTotalModule });
PerfTabCumulativeTotalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabCumulativeTotalModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabCumulativeTotalComponent],
                imports: [CommonModule],
                exports: [PerfTabCumulativeTotalComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabCumulativeTotalModule, { declarations: [PerfTabCumulativeTotalComponent], imports: [CommonModule], exports: [PerfTabCumulativeTotalComponent] }); })();

class PerfTabDistributionsComponent {
    constructor() { }
    ngOnInit() { }
}
PerfTabDistributionsComponent.ɵfac = function PerfTabDistributionsComponent_Factory(t) { return new (t || PerfTabDistributionsComponent)(); };
PerfTabDistributionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabDistributionsComponent, selectors: [["ft-alts-perf-tab-distributions"]], decls: 2, vars: 0, template: function PerfTabDistributionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "perf-tab-distributions works!");
        i0.ɵɵelementEnd();
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDistributionsComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-distributions',
                templateUrl: './perf-tab-distributions.component.html',
                styleUrls: ['./perf-tab-distributions.component.scss'],
            }]
    }], function () { return []; }, null); })();

class PerfTabDistributionsModule {
}
PerfTabDistributionsModule.ɵfac = function PerfTabDistributionsModule_Factory(t) { return new (t || PerfTabDistributionsModule)(); };
PerfTabDistributionsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabDistributionsModule });
PerfTabDistributionsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDistributionsModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabDistributionsComponent],
                imports: [CommonModule],
                exports: [PerfTabDistributionsComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabDistributionsModule, { declarations: [PerfTabDistributionsComponent], imports: [CommonModule], exports: [PerfTabDistributionsComponent] }); })();

function PerfTabMonthlyCalendarComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "ft-alts-switch", 11);
    i0.ɵɵlistener("switchState", function PerfTabMonthlyCalendarComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(2); return ctx_r2.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r1.switchdata.offLabel)("onLabel", ctx_r1.switchdata.onLabel)("state", ctx_r1.switchdata.state);
} }
const _c0$1 = function (a0) { return { "pt-monthly-calendar__table-header": a0 }; };
function PerfTabMonthlyCalendarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementStart(6, "h2", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabMonthlyCalendarComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "ft-alts-perf-table", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$1, !i0.ɵɵpipeBind1(5, 5, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.switchdata);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tableData", ctx_r0.tableData);
} }
class PerfTabMonthlyCalendarComponent {
    constructor(responsiveService, cdr) {
        this.responsiveService = responsiveService;
        this.cdr = cdr;
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having performance tab content
     */
    mapContent(document) {
        var _a;
        const tabData = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        if (tabData) {
            this.bgColor = tabData.bgColor;
            this.tabTitle = tabData.title;
            this.switchdata = tabData.switchdata;
            this.shareClass = tabData.class;
            this.categories = tabData.categories;
            this.performanceMetadata = tabData.performanceMetadata;
            if (this.performanceMetadata) {
                this.onSwitchPressed(this.switchdata.state);
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare table data accordingly.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata.monthEnd);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata.quarterEnd);
        }
        // Step 2: Get table data by processing selected performance data and current state.
        this.tableData = this.prepareTableData(this.selectedPerformanceData);
        // Step 3: Finally, update the child component - table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Prepare complete table metadata as required.
     * Uses 'categories' for binding x-axes to table header, and, 'tableData' for y-axes (plots) to table body.
     * @param selectedPerformanceData currently selected performance data as per current switch state
     * @param currentState currently seleted switch state
     */
    prepareTableData(selectedPerformanceData) {
        const headData = [];
        const bodyData = [];
        // Step 1: Add row header at first, followed by column headers to header data.
        headData.push({
            label: this.shareClass,
        }, ...this.categories.map((category) => {
            return {
                label: category,
            };
        }));
        // Step 2: Add row header for every row, followed by column values to each row.
        bodyData.push(...selectedPerformanceData.tableData.map((tableDataObj) => {
            return [
                {
                    value: tableDataObj.year,
                },
                ...tableDataObj.data.map((plot) => {
                    return {
                        value: plot,
                    };
                }),
            ];
        }));
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabMonthlyCalendarComponent.ɵfac = function PerfTabMonthlyCalendarComponent_Factory(t) { return new (t || PerfTabMonthlyCalendarComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfTabMonthlyCalendarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabMonthlyCalendarComponent, selectors: [["ft-alts-perf-tab-monthly-calendar"]], inputs: { component: "component", page: "page" }, decls: 1, vars: 1, consts: [["class", "pt-monthly-calendar", 4, "ngIf"], [1, "pt-monthly-calendar"], [1, "grid"], [1, "row", "pt-monthly-calendar__max-width-970"], [1, "col", "l12", "m8", "s4", "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "title--h4", "color--ft-white", "spacing--xs"], ["class", "spacing--lg", 4, "ngIf"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "tableData"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"]], template: function PerfTabMonthlyCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabMonthlyCalendarComponent_div_0_Template, 12, 9, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i2.NgIf, i2.NgClass, PerfTableComponent, i1.SwitchComponent], pipes: [i2.AsyncPipe], styles: ["@media (min-width: 1200px){.pt-monthly-calendar__max-width-970[_ngcontent-%COMP%]{max-width:970px}}.pt-monthly-calendar__table-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabMonthlyCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-monthly-calendar',
                templateUrl: './perf-tab-monthly-calendar.component.html',
                styleUrls: ['./perf-tab-monthly-calendar.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i0.ChangeDetectorRef }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfTabMonthlyCalendarModule {
}
PerfTabMonthlyCalendarModule.ɵfac = function PerfTabMonthlyCalendarModule_Factory(t) { return new (t || PerfTabMonthlyCalendarModule)(); };
PerfTabMonthlyCalendarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabMonthlyCalendarModule });
PerfTabMonthlyCalendarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfTableModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabMonthlyCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabMonthlyCalendarComponent],
                imports: [CommonModule, SwitchModule, PerfTableModule],
                exports: [PerfTabMonthlyCalendarComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabMonthlyCalendarModule, { declarations: [PerfTabMonthlyCalendarComponent], imports: [CommonModule, SwitchModule, PerfTableModule], exports: [PerfTabMonthlyCalendarComponent] }); })();

function PerfFooterComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const caveat_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", caveat_r1, " ");
} }
const _c0 = function (a0) { return { "perf-footer__section__cta-bg--mobile": a0 }; };
const _c1 = function (a0) { return { "width--max": a0 }; };
class PerfFooterComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having footer content
     */
    mapContent(document) {
        var _a;
        const { caveats, tableData, ctaBannerImage, title, subTitle, actionButton, } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.caveats = caveats;
        this.tableData = tableData;
        this.ctaBannerImage = ctaBannerImage;
        this.title = title;
        this.subTitle = subTitle;
        this.actionButton = actionButton;
    }
}
PerfFooterComponent.ɵfac = function PerfFooterComponent_Factory(t) { return new (t || PerfFooterComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService)); };
PerfFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfFooterComponent, selectors: [["ft-alts-perf-footer"]], inputs: { component: "component", page: "page" }, decls: 17, vars: 18, consts: [[1, "color--ft-white", "spacing--md", "perf-footer"], ["class", "font-p--b", 4, "ngFor", "ngForOf"], [3, "tableData"], [1, "grid", "perf-footer__section"], [1, "row", "perf-footer__section__cta-bg", 3, "ngClass"], [1, "col", "l4", "m8", "s4", "perf-footer__section__col-left"], [1, "perf-footer__section__col-left__content"], [3, "src", "alt", "ngClass"], [1, "col", "l6", "m8", "s4"], [1, "perf-footer__section__col-right__content"], [1, "title--h3", "spacing--md"], [1, "spacing--md", "font-p-lrg"], [3, "link", "variant", "buttonClicked"], [1, "font-p--b"]], template: function PerfFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PerfFooterComponent_p_1_Template, 2, 1, "p", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ft-alts-perf-table", 2);
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelement(8, "img", 7);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "h2", 10);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "p", 11);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "ft-alts-button", 12);
        i0.ɵɵlistener("buttonClicked", function PerfFooterComponent_Template_ft_alts_button_buttonClicked_16_listener() { return null; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.caveats);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tableData", ctx.tableData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0, i0.ɵɵpipeBind1(5, 10, ctx.isHandheld$)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", ctx.ctaBannerImage == null ? null : ctx.ctaBannerImage.path, i0.ɵɵsanitizeUrl)("alt", ctx.ctaBannerImage == null ? null : ctx.ctaBannerImage.altText)("ngClass", i0.ɵɵpureFunction1(16, _c1, i0.ɵɵpipeBind1(9, 12, ctx.isHandheld$)));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.subTitle);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("link", ctx.actionButton)("variant", "v2");
    } }, directives: [i2.NgForOf, PerfTableComponent, i2.NgClass, i1.ButtonComponent], pipes: [i2.AsyncPipe], styles: [".perf-footer[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:not(:last-child){margin-bottom:1.2em}.perf-footer__section[_ngcontent-%COMP%]{margin:0!important;padding-top:var(--space-xl)}.perf-footer__section__cta-bg[_ngcontent-%COMP%]{padding-top:var(--space-lg);background:var(--ft-gradient-transparent-to-purple-v2);flex-direction:row}.perf-footer__section__cta-bg--mobile[_ngcontent-%COMP%]{flex-direction:column-reverse}.perf-footer__section__col-left[_ngcontent-%COMP%]{margin-bottom:calc(-1 * var(--space-s))}.perf-footer__section__col-left__content[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:flex-end;height:100%}.perf-footer__section__col-left__content[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:344px;height:auto;object-fit:cover;vertical-align:bottom}.perf-footer__section__col-right[_ngcontent-%COMP%]{text-align:left}.perf-footer__section__col-right__content[_ngcontent-%COMP%]{height:100%;display:flex;margin:0;padding-bottom:var(--space-lg);justify-content:center;flex-direction:column;color:var(--ft-white)}.width--max[_ngcontent-%COMP%]{max-width:100%!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-footer',
                templateUrl: './perf-footer.component.html',
                styleUrls: ['./perf-footer.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfFooterModule {
}
PerfFooterModule.ɵfac = function PerfFooterModule_Factory(t) { return new (t || PerfFooterModule)(); };
PerfFooterModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfFooterModule });
PerfFooterModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, PerfTableModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfFooterComponent],
                imports: [CommonModule, PerfTableModule, ButtonModule],
                exports: [PerfFooterComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfFooterModule, { declarations: [PerfFooterComponent], imports: [CommonModule, PerfTableModule, ButtonModule], exports: [PerfFooterComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PerfChartComponent, PerfChartModule, PerfFooterComponent, PerfFooterModule, PerfHeaderComponent, PerfHeaderModule, PerfTabAverageAnnualComponent, PerfTabAverageAnnualModule, PerfTabCumulativeTotalComponent, PerfTabCumulativeTotalModule, PerfTabDistributionsComponent, PerfTabDistributionsModule, PerfTabMonthlyCalendarComponent, PerfTabMonthlyCalendarModule, PerfTableComponent, PerfTableModule, PerfTabsComponent, PerfTabsModule, PerfTabsService };
